import { AsyncPipe, NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FileInputComponent } from '../file-input/file-input.component';

@Component({
    selector: 'valben-multiple-file-input',
    standalone: true,
    imports: [FileInputComponent, AsyncPipe, NgClass],
    templateUrl: './multiple-file-input.component.html',
})
export class MultipleFileInputComponent implements OnInit {
    @Input() key!: string
    @Input() update!: (value: any) => void
    @Input() itemObservable!: () => Observable<any> | undefined
    @Input() title: string = ''
    @Input() error: boolean = false
    @Input() optional: boolean = false
    @Input() isKng: boolean = true
    @Input() singleIndex?: number;
    selectedFiles: File[] = []
    updateMethods: ((value: any) => void)[] = []
    filesArray: any[] = [];

    ngOnInit(): void {
        this.itemObservable()?.subscribe(value => {
            if (!value) return;

            let files: any[] = Array.isArray(value[this.key]) ? value[this.key] : [];

            if (this.singleIndex !== undefined) {
                const file = files[this.singleIndex] ?? null;
                files = [file];
            }

            this.selectedFiles = files;

            const count = this.selectedFiles.length;
            this.updateMethods = [];

            for (let i = 0; i < count; i++) {
                this.updateMethods.push((file: any) => {
                    if (this.singleIndex !== undefined) {
                        this.itemObservable()?.subscribe(current => {
                            const updated = [...(current?.[this.key] ?? [])];

                            while (updated.length <= this.singleIndex!) {
                                updated.push(null);
                            }

                            updated[this.singleIndex!] = file;
                            this.update(updated);
                        });
                        return;
                    }

                    const filesCopy = this.selectedFiles.slice();
                    if (i < filesCopy.length) {
                        filesCopy[i] = file;
                    } else {
                        filesCopy.push(file);
                    }
                    this.update(filesCopy);
                });
            }

            this.filesArray = this.selectedFiles.map((file, index) => ({
                file,
                updateMethod: this.updateMethods[index]
            }));
        });
    }
}
